import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RecruitmentService } from '../recruitment.service';
import { IGeneralData } from 'app/shared/models/recruitment/general-data.model';
import { IRecruiterComment } from 'app/shared/models/recruitment/recruiter-comment.model';
import { IStudy } from 'app/shared/models/recruitment/study.model';
import { IAppearance } from 'app/shared/models/recruitment/appearance.model';
import { IEmploymentHistory } from 'app/shared/models/recruitment/employment-history.model';
import { IEmploymentHistoryItem } from 'app/shared/models/recruitment/employment-history-item.model';
import { IReference } from 'app/shared/models/recruitment/reference.model';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

declare var $: any;
@Component({
  selector: 'app-profile',
  styleUrls: ['./profile.style.scss'],
  templateUrl: 'profile.template.html'
})
export class ProfileComponent implements OnInit {
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.module = params['module'];
        setTimeout(() => {
          this.spinner.show();
          this.getJobCandidatesById(Number(params['id']));
        }, 2);

      }
    });
  }

  private jobCandidate: IGeneralData;
  private jobCandidateComment: IRecruiterComment;
  private jobCandidateLevelEducation: IStudy;
  private jobCandidateAppearance: IAppearance;
  private jobCandidateHistory: IEmploymentHistory;
  private jobCandidateHistoryItem: IEmploymentHistoryItem[];
  private jobCandidateReferences: IReference[];
  private navigationSubscription: any;
  private module: string;
  public constructor(private recruitmentService: RecruitmentService
    , private spinner: NgxSpinnerService
    , private route: ActivatedRoute
    , private router: Router) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.initialiseRoute();
      }
    });
  }
  private initialiseRoute() {
    this.resetForm();
  }
  private resetForm() {
    this.jobCandidate = {} as IGeneralData;
    this.jobCandidateComment = {} as IRecruiterComment;
    this.jobCandidateLevelEducation = {} as IStudy;
    this.jobCandidateAppearance = {} as IAppearance;
    this.jobCandidateHistory = {} as IEmploymentHistory;
    this.jobCandidateHistoryItem = [];
    this.jobCandidateReferences = [];
  }
  private navigateToEdit(): void {
    this.router.navigate(['/recruitments/request',
      { id: this.jobCandidate.id, action: 'update' }], { relativeTo: this.route });
  }
  private getJobCandidatesById(id: number): void {
    this.recruitmentService.getJobCandidate(id).subscribe((res) => {
      console.log(res);
      if (res != null) {
        this.jobCandidate = res;
        this.jobCandidateComment = res.jobCandidateRecruiterComment;
        this.jobCandidateLevelEducation = res.jobCandidateLevelEducation;
        this.jobCandidateAppearance = res.jobCandidateAppearance;
        this.jobCandidateHistory = res.jobCandidateEmploymentHistory;
        this.jobCandidateHistoryItem = res.jobCandidateEmploymentHistory != null ? res.jobCandidateEmploymentHistory.jobCandidateEmploymentHistoryItem : null;
        this.jobCandidateReferences = res.jobCandidateReference;
      }
      this.spinner.hide();
    });
  }
  private convertBoolToString(value: boolean) {
    if (value != null) {
      if (value)
        return "SI";
      else
        return "NO";
    }
  }
  private calculateLaborOld(startDate: Date, endDate: Date, calculateYear: boolean): number {
    let old = 0;
    if (calculateYear)
      old = new Date(endDate).getFullYear() - new Date(startDate).getFullYear();
    else
      old = new Date(endDate).getMonth() - new Date(startDate).getMonth();
    return Math.abs(old);
  }
  private printPDF() {
    window.print();
  }
}
